import Model from './Model'

export default class Feature extends Model {

    schema() {
        return {
            id: null,
            name: null,
            mf_name: [],
            display_priority: 10,
            created_at: null,
            updated_at: null,
            shop_id: null,
            editMode: false,
            inlineLoader: false,
            datasEditInline: {},
        }
    }

    populateEditMode() {
        this.datasEditInline = {
            name: this.name,
            shop_id: this.shop_id,
        }
    }

    setEditMode() {
        this.editMode = true
        this.populateEditMode();
    }

    cancelEditMode() {
        this.editMode = false
    }

    saveEditMode() {
        this.cancelEditMode()
        this.name = this.datasEditInline.name
        this.shop_id = this.datasEditInline.shop_id
        return this.datasEditInline
    }

}
